// extracted by mini-css-extract-plugin
export default {"productCarousel":"o0-z"};